import React, { Component } from 'react';
import { GeckoIcon } from '../../../../../../components';
import './styles.css';
import moment from 'moment';


export class ActivityTable extends Component {
    constructor(props) {
        super(props);

        this.renderRows = this.renderRows.bind(this);
        this.prepareRowData = this.prepareRowData.bind(this);
    }

    cleanValue(value) {
        const NO_VALUE = '--';

        if (!value || value === 'null') {
            return NO_VALUE;
        }

        return value;
    }

    prepareRowData(rawData) {
        let preparedData = {
            type: null,
            createdAt: null,
            eventResponse: null,

            ipAddress: null,
            deviceName: null,
            country: null,
            timezone: null,
        };

        if (rawData.EventContextData) {
            preparedData.ipAddress = this.cleanValue(rawData.EventContextData.IpAddress);
            preparedData.deviceName = this.cleanValue(rawData.EventContextData.DeviceName);
            preparedData.country = this.cleanValue(rawData.EventContextData.Country);
            preparedData.timezone = rawData.EventContextData.Timezone;
        }

        let userFacingTimezone = (preparedData.timezone ? '(' + preparedData.timezone + ')' : '');

        preparedData.type = rawData.EventType;
        preparedData.eventResponse = rawData.EventResponse;
        preparedData.createdAt = moment(rawData.CreationDate).utc().format('Do MMM YYYY HH:mm') + ' ' + userFacingTimezone;

        return preparedData;
    }

    renderRows(data) {
        return data.map((event, key) => {
            return <div key={key}>{ActivityRow(this.prepareRowData(event))}</div>;
        })
    }

    render() {
        return (
            <div id="activityTable">
                {this.renderRows(this.props.data)}
            </div>

        )
    }
}

ActivityTable.defaultProps = {
    data: [],
}


export const ActivityRow = ({type = '', createdAt = '', ipAddress = '', deviceName = '', country = '', eventResponse = null}) => (
    <div className="eventRow">
        <div className="d-flex flex-row ">
            <div className="eventType d-flex flex-row align-items-center">
                <span>{type}</span> 
                {EventResponseBadge(eventResponse)}
            </div>
        </div>

        <div className="d-flex flex-row primary flex-wrap justify-content-between">
            <div className="meta" title="Device Name"><GeckoIcon icon="desktop" /> {deviceName}</div>
            <div className="meta" title="Timestamp"><GeckoIcon icon="clock" /> {createdAt}</div>
            <div className="meta" title="Country"><GeckoIcon icon="globe-europe" /> {country}</div>
            <div className="meta" title="IP Address"><GeckoIcon icon="network-wired" /> {ipAddress}</div>
        </div>
    </div>
);

export const EventResponseBadge = (value) => {
    if (!value || value === '') {
        return null;
    }

    if (value === 'Fail') {
        return <span className="activityBadge activityFailed">Failed</span>
    }

    return null;
}

export default ActivityTable;